import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";

export const getAssetType = () => {
  return {
    value: AssetTypes.Portfolio.Object,
    label: i18n.t("Component.PDFConstructor.AssetTypes.Object", "Objekt"),
  };
};
